import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  style: {"enable-background":"new 0 0 16 16"},
  "xml:space": "preserve",
  xmlns: "http://www.w3.org/2000/svg",
  width: "16",
  height: "16",
  fill: "currentColor",
  class: "qi-1402"
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("path", { d: "M13.782 5.158a.562.562 0 0 0-.093-1.044L5.093 1.649l-.006-.003-.008-.001-.05-.015-.002.01a.692.692 0 0 0-.808.48L.944 13.287a.701.701 0 0 0 .672.897.7.7 0 0 0 .671-.503l.981-3.347 10.514-5.176zm1.377 3.777L11.375 7.85c-.011-.004-.018-.012-.029-.015-.012-.003-.023 0-.035-.003l-.042-.012-.002.008a.692.692 0 0 0-.79.482l-1.263 4.294a.7.7 0 1 0 1.342.393l.449-1.528L15.2 9.404a.252.252 0 0 0-.041-.469z" }, null, -1)
const _hoisted_3 = [
  _hoisted_2
]

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _hoisted_3))
}
export default { render: render }